// apps/web hosting domains per environment. apps/admin runs on a separate
// hosting deployment, so it deep-links into the web app — where the chat
// session, Firebase identity, and the login page that newly-created users
// need actually live. Prod is the bare apex domain; dev/stg are sub-domains
// (see memory: reference_environment_urls + firebase/functions CORS allowlist).
export const WEB_APP_URL_BY_ENV: Record<string, string> = {
  development: 'https://dev.dashone.dashmote.com',
  staging: 'https://staging.dashone.dashmote.com',
  production: 'https://dashone.dashmote.com',
};

// Resolve the web-app base URL for the environment this admin build targets.
// `VITE_WEB_APP_URL` overrides when set; otherwise map from `VITE_ENVIRONMENT`,
// falling back to production. Trailing slashes are stripped so callers can
// safely append a path (e.g. `${getWebAppUrl()}/login`).
export function getWebAppUrl(): string {
  const explicit = import.meta.env.VITE_WEB_APP_URL as string | undefined;
  if (explicit) return explicit.replace(/\/+$/, '');
  const env =
    (import.meta.env.VITE_ENVIRONMENT as string | undefined) || 'production';
  return (WEB_APP_URL_BY_ENV[env] || WEB_APP_URL_BY_ENV.production).replace(
    /\/+$/,
    ''
  );
}

// A chat lives in the web app, so the admin portal links to it there. The web
// app opens another user's chat read-only for a Dashmote admin.
export function getWebChatUrl(chatId: string): string {
  return `${getWebAppUrl()}/ai/chat/${encodeURIComponent(chatId)}`;
}
